import React from 'react';
import { translate } from '../services';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';

export const Availability = ( { shortForm, stock } ) => {
  let isAvailable = stock > 0;
  let className = classNames( { 'available': isAvailable, 'not-available': !isAvailable } );

  let text = translate( '{tr:available} {stock}',
    { available: isAvailable ? 'Available: ' : 'Unavailable',
      stock: isAvailable ? stock : '' }
  );

  if ( shortForm ) {
    text = isAvailable ? stock : '';
  }

  return <span className={ className }>
    <span className="ellipsed hide-on-medium hide-on-small">{ text }</span>
  </span>;
};

Availability.propTypes = {
  shortForm: PropTypes.bool,
  stock: PropTypes.string
};